import { z } from 'zod';

// src/metadata-analytics/protocolNames.ts

// src/metadata-analytics/protocol-names.generated.json
var protocol_names_generated_default = {
  categories: {
    aave_v3: "lending",
    account_closure: "infrastructure",
    across: "bridge",
    address_lookup_table: "infrastructure",
    aerodrome: "exchange",
    aldrin: "exchange",
    aldrin_v2: "exchange",
    alphaq: "exchange",
    angstrom: "exchange",
    ape_church: "gambling",
    aquifer: "exchange",
    arbitrage_bot_foaft: "mev",
    arbos: "infrastructure",
    archer: "exchange",
    associated_token_account: "erc20",
    babylon_staking: "staking",
    banana_gun: "mev",
    binaryfi: "exchange",
    bisonfi: "exchange",
    bisonfi_predict: "exchange",
    bitcoin_stamps: "nft",
    bonkswap: "exchange",
    boop_fun: "exchange",
    bpf_loader_upgradeable: "infrastructure",
    brc20: "erc20",
    byreal: "exchange",
    carrot: "staking",
    cctp: "bridge",
    chainflip: "bridge",
    chainlink_automation: "oracle",
    chainlink_ccip: "bridge",
    chainlink_direct_request: "oracle",
    chainlink_functions: "oracle",
    compute_budget: "infrastructure",
    conditional_tokens: "derivatives",
    coredao: "staking",
    cosmos_authz: "account_abstraction",
    cosmos_bank: "infrastructure",
    cosmos_distribution: "staking",
    cosmos_feegrant: "account_abstraction",
    cosmos_gov: "governance",
    cosmos_staking: "staking",
    cosmwasm: "infrastructure",
    counterparty: "exchange",
    cowswap: "exchange",
    crema: "exchange",
    cropper: "exchange",
    cryptopunks: "nft",
    defituna: "exchange",
    denali: "exchange",
    deriverse: "exchange",
    dexlab: "exchange",
    dflow_aggregator_v4: "aggregator",
    ed25519_program: "infrastructure",
    eip7702: "account_abstraction",
    ens: "nft",
    erc1155: "nft",
    erc20: "erc20",
    erc4337: "account_abstraction",
    erc4626: "lending",
    erc721: "nft",
    flint: "exchange",
    flux: "exchange",
    fluxbeam: "exchange",
    gatorswap: "exchange",
    gavel: "exchange",
    generic: "other",
    gnosis_safe: "safe",
    goonfi_v2: "exchange",
    goosefx_gamma: "exchange",
    guacswap: "exchange",
    hadron: "exchange",
    heaven: "exchange",
    helium_treasury: "staking",
    hop: "bridge",
    huma: "staking",
    humidifi: "exchange",
    hylo_exchange: "staking",
    hylo_stability_pool: "staking",
    hyperlane: "bridge",
    hyperliquid_account: "account_abstraction",
    hyperliquid_bridge: "bridge",
    hyperliquid_bridge2: "bridge",
    hyperliquid_evm: "infrastructure",
    hyperliquid_staking: "staking",
    hyperliquid_trading: "derivatives",
    hyperliquid_transfer: "exchange",
    hyperliquid_validator: "infrastructure",
    hyperliquid_vault: "derivatives",
    ibc_core: "infrastructure",
    ibc_transfer: "bridge",
    invariant: "exchange",
    jaredfromsubway: "mev",
    joinmarket_coinjoin: "privacy",
    jupiter_dca: "exchange",
    jupiter_lend_earn: "lending",
    jupiter_limit_order: "exchange",
    jupiter_limit_order_v2: "exchange",
    jupiter_perps: "derivatives",
    jupiter_rfq_v2: "exchange",
    jupiter_v4: "aggregator",
    jupiter_v6: "aggregator",
    juplend_amm: "exchange",
    kipseli: "exchange",
    kyberswap_meta_aggregator: "aggregator",
    layerzero_oft: "bridge",
    layerzero_v1: "bridge",
    layerzero_v2: "bridge",
    lemmingsfi: "exchange",
    lifi: "aggregator",
    lifinity_v2: "exchange",
    lighthouse: "infrastructure",
    limitbreak_payment_processor: "nft",
    m_swap: "exchange",
    magic_eden_v2: "nft",
    manifest: "exchange",
    marinade: "staking",
    mayan: "bridge",
    mercurial: "exchange",
    metadao: "exchange",
    metamask_bridge: "aggregator",
    metaplex_bubblegum: "nft",
    metaplex_core: "nft",
    metaplex_token_metadata: "nft",
    meteora_damm_v2: "exchange",
    meteora_dbc: "exchange",
    meteora_dlmm: "exchange",
    meteora_pools: "exchange",
    metric: "exchange",
    mev_bot: "mev",
    monero_ringct: "privacy",
    moonit: "exchange",
    multicall: "aggregator",
    native_transfer: "erc20",
    near_intents: "bridge",
    obric_v2: "exchange",
    obsidian: "exchange",
    okx_dex_router: "aggregator",
    okx_xbridge: "aggregator",
    omni_layer: "erc20",
    omnipair: "exchange",
    one_dex: "exchange",
    oneinch: "aggregator",
    op_return_data: "other",
    op_stack_l1_block: "infrastructure",
    openbook_v2: "exchange",
    orca_v1: "exchange",
    orca_v2: "exchange",
    orca_whirlpool: "exchange",
    ordinals: "nft",
    osmosis_swap: "exchange",
    pancakeswap_factory: "exchange",
    pancakeswap_router: "exchange",
    pancakeswap_solana: "exchange",
    pancakeswap_v3_pool: "exchange",
    penguin: "exchange",
    perena: "exchange",
    perena_star_v2: "staking",
    phoenix: "exchange",
    phoenix_eternal: "derivatives",
    polymarket_ctf_exchange: "derivatives",
    polymarket_neg_risk: "derivatives",
    polymarket_uma_adapter: "derivatives",
    pons_v2_curve: "exchange",
    pons_v2_factory: "exchange",
    privacy_pools: "privacy",
    program_metadata: "infrastructure",
    pumpfun: "exchange",
    pumpfun_fee: "exchange",
    pumpswap_amm: "exchange",
    quantum: "exchange",
    quay: "exchange",
    railgun: "privacy",
    raydium_amm_v4: "exchange",
    raydium_clmm: "exchange",
    raydium_cpmm: "exchange",
    raydium_launchlab: "exchange",
    relay: "bridge",
    riptide: "exchange",
    rootstock: "bridge",
    runes: "erc20",
    runner_rodeo: "exchange",
    saber: "exchange",
    saber_decimals: "exchange",
    sanctum_infinity: "staking",
    sanctum_multi_validator: "staking",
    sanctum_prop_s: "staking",
    sanctum_router: "staking",
    sanctum_single_validator: "staking",
    sanctum_sols: "staking",
    sanctum_spl_stake_pool: "staking",
    saros: "exchange",
    saros_dlmm: "exchange",
    scale_amm: "exchange",
    scale_vmm: "exchange",
    scorch: "exchange",
    scorch_2: "exchange",
    seaport: "nft",
    secp256k1_program: "infrastructure",
    solayer: "staking",
    solfi: "exchange",
    solfi_v2: "exchange",
    spl_memo_v1: "infrastructure",
    spl_memo_v2: "infrastructure",
    spl_token: "erc20",
    spl_token_2022: "erc20",
    spl_token_swap: "exchange",
    stabble_clmm: "exchange",
    stabble_stable_swap: "exchange",
    stabble_weighted_swap: "exchange",
    stableswap: "exchange",
    stacks: "infrastructure",
    stake: "infrastructure",
    stargate: "bridge",
    stepn: "exchange",
    sushiswap_router: "exchange",
    sushiswap_v2_factory: "exchange",
    system: "infrastructure",
    taurusfi: "exchange",
    tensor_swap: "nft",
    tessera_v: "exchange",
    thorchain: "bridge",
    thorchain_deposit: "bridge",
    thorchain_memo: "bridge",
    thorchain_node: "infrastructure",
    tokemak_messaging: "bridge",
    tornado_cash: "privacy",
    tornado_cash_nova: "privacy",
    trench: "exchange",
    trends: "exchange",
    uma_optimistic_oracle: "oracle",
    unattributed_coinjoin: "privacy",
    uniswap_permit2: "exchange",
    uniswap_universal_router: "exchange",
    uniswap_v1_exchange: "exchange",
    uniswap_v1_factory: "exchange",
    uniswap_v2_factory: "exchange",
    uniswap_v2_pair: "exchange",
    uniswap_v2_router: "exchange",
    uniswap_v3_factory: "exchange",
    uniswap_v3_pool: "exchange",
    uniswap_v3_position_manager: "exchange",
    uniswap_v3_router: "exchange",
    uniswap_v4: "exchange",
    uniswap_v4_position_manager: "exchange",
    usdt0: "bridge",
    vault_liquid_unstake: "staking",
    virtuals: "exchange",
    voltr: "staking",
    vote: "infrastructure",
    wasabi_coinjoin: "privacy",
    whalestreet: "exchange",
    whirlpool_coinjoin: "privacy",
    wintermute: "mev",
    woofi: "exchange",
    wormhole: "bridge",
    xorca: "staking",
    zcash_shielded: "privacy",
    zeroex: "exchange",
    zerofi: "exchange",
    zkbob: "privacy"
  },
  names: {
    aave_v3: "Aave V3",
    account_closure: "Account closure",
    across: "Across Protocol",
    address_lookup_table: "Address Lookup Table",
    aerodrome: "Aerodrome / Velodrome",
    aldrin: "Aldrin",
    aldrin_v2: "Aldrin v2",
    alphaq: "AlphaQ",
    angstrom: "Angstrom",
    ape_church: "Ape Church",
    aquifer: "Aquifer",
    arbitrage_bot_foaft: "Arbitrage Bot (FoaFt)",
    arbos: "ArbOS",
    archer: "Archer",
    associated_token_account: "Associated Token Account",
    babylon_staking: "Babylon",
    banana_gun: "Banana Gun",
    binaryfi: "BinaryFi",
    bisonfi: "BisonFi",
    bisonfi_predict: "BisonFi Predict",
    bitcoin_stamps: "Bitcoin Stamps",
    bonkswap: "Bonkswap",
    boop_fun: "Boop.fun",
    bpf_loader_upgradeable: "BPF Upgradeable Loader",
    brc20: "BRC-20",
    byreal: "Byreal",
    carrot: "Carrot",
    cctp: "Circle CCTP",
    chainflip: "Chainflip",
    chainlink_automation: "Chainlink Automation",
    chainlink_ccip: "Chainlink CCIP",
    chainlink_direct_request: "Chainlink Direct Request",
    chainlink_functions: "Chainlink Functions",
    compute_budget: "Compute Budget",
    conditional_tokens: "Conditional Tokens",
    coredao: "Core DAO",
    cosmos_authz: "Cosmos authz",
    cosmos_bank: "Cosmos bank",
    cosmos_distribution: "Cosmos staking rewards",
    cosmos_feegrant: "Cosmos fee grants",
    cosmos_gov: "Cosmos governance",
    cosmos_staking: "Cosmos staking",
    cosmwasm: "CosmWasm",
    counterparty: "Counterparty",
    cowswap: "CoW Swap",
    crema: "Crema",
    cropper: "Cropper",
    cryptopunks: "CryptoPunks",
    defituna: "DefiTuna",
    denali: "Denali",
    deriverse: "Deriverse",
    dexlab: "DexLab",
    dflow_aggregator_v4: "DFlow",
    ed25519_program: "Ed25519 Signature Verify",
    eip7702: "EIP-7702 delegation",
    ens: "ENS",
    erc1155: "ERC1155",
    erc20: "ERC20",
    erc4337: "ERC-4337",
    erc4626: "ERC4626",
    erc721: "ERC721",
    flint: "Flint",
    flux: "Flux",
    fluxbeam: "FluxBeam",
    gatorswap: "GatorSwap",
    gavel: "Gavel",
    generic: "Generic",
    gnosis_safe: "Gnosis Safe",
    goonfi_v2: "GoonFi v2",
    goosefx_gamma: "GooseFX Gamma",
    guacswap: "Guacswap",
    hadron: "Hadron",
    heaven: "Heaven",
    helium_treasury: "Helium Treasury Management",
    hop: "Hop",
    huma: "Huma",
    humidifi: "HumidiFi",
    hylo_exchange: "Hylo Exchange",
    hylo_stability_pool: "Hylo Stability Pool",
    hyperlane: "Hyperlane",
    hyperliquid_account: "Hyperliquid account",
    hyperliquid_bridge: "Hyperliquid bridge",
    hyperliquid_bridge2: "Hyperliquid Bridge2",
    hyperliquid_evm: "HyperEVM via HyperCore",
    hyperliquid_staking: "Hyperliquid staking",
    hyperliquid_trading: "Hyperliquid trading",
    hyperliquid_transfer: "Hyperliquid transfers",
    hyperliquid_validator: "Hyperliquid validators and deployers",
    hyperliquid_vault: "Hyperliquid vaults",
    ibc_core: "IBC relayer",
    ibc_transfer: "IBC transfer",
    invariant: "Invariant",
    jaredfromsubway: "jaredfromsubway",
    joinmarket_coinjoin: "JoinMarket CoinJoin",
    jupiter_dca: "Jupiter DCA",
    jupiter_lend_earn: "Jupiter Lend Earn",
    jupiter_limit_order: "Jupiter Limit Order",
    jupiter_limit_order_v2: "Jupiter Limit Order v2",
    jupiter_perps: "Jupiter Perps",
    jupiter_rfq_v2: "Jupiter RFQ",
    jupiter_v4: "Jupiter v4",
    jupiter_v6: "Jupiter",
    juplend_amm: "JupLend AMM",
    kipseli: "Kipseli",
    kyberswap_meta_aggregator: "KyberSwap",
    layerzero_oft: "LayerZero OFT",
    layerzero_v1: "LayerZero V1",
    layerzero_v2: "LayerZero V2",
    lemmingsfi: "LemmingsFi",
    lifi: "LI.FI",
    lifinity_v2: "Lifinity v2",
    lighthouse: "Lighthouse",
    limitbreak_payment_processor: "Payment Processor (Limit Break)",
    m_swap: "M Swap",
    magic_eden_v2: "Magic Eden v2",
    manifest: "Manifest",
    marinade: "Marinade Finance",
    mayan: "Mayan",
    mercurial: "Mercurial",
    metadao: "MetaDAO",
    metamask_bridge: "MetaMask Bridge",
    metaplex_bubblegum: "Metaplex Bubblegum",
    metaplex_core: "Metaplex Core",
    metaplex_token_metadata: "Metaplex Token Metadata",
    meteora_damm_v2: "Meteora DAMM v2",
    meteora_dbc: "Meteora Dynamic Bonding Curve",
    meteora_dlmm: "Meteora DLMM",
    meteora_pools: "Meteora Pools",
    metric: "Metric",
    mev_bot: "MEV Bot",
    monero_ringct: "Monero RingCT",
    moonit: "Moonit",
    multicall: "Multicall",
    native_transfer: "Native transfer",
    near_intents: "NEAR Intents",
    obric_v2: "Obric v2",
    obsidian: "Obsidian",
    okx_dex_router: "OKX DEX Router",
    okx_xbridge: "OKX XBridge",
    omni_layer: "Omni Layer",
    omnipair: "Omnipair",
    one_dex: "1DEX",
    oneinch: "1inch",
    op_return_data: "OP_RETURN data",
    op_stack_l1_block: "OP Stack L1Block",
    openbook_v2: "OpenBook v2",
    orca_v1: "Orca v1",
    orca_v2: "Orca v2",
    orca_whirlpool: "Orca Whirlpool",
    ordinals: "Ordinals",
    osmosis_swap: "Osmosis",
    pancakeswap_factory: "PancakeSwap",
    pancakeswap_router: "PancakeSwap",
    pancakeswap_solana: "PancakeSwap",
    pancakeswap_v3_pool: "PancakeSwap",
    penguin: "Penguin",
    perena: "Perena",
    perena_star_v2: "Perena Star v2",
    phoenix: "Phoenix",
    phoenix_eternal: "Phoenix Eternal",
    polymarket_ctf_exchange: "Polymarket CTF Exchange",
    polymarket_neg_risk: "Polymarket Neg Risk",
    polymarket_uma_adapter: "Polymarket UMA Adapter",
    pons_v2_curve: "Pons V2 curve",
    pons_v2_factory: "Pons V2",
    privacy_pools: "Privacy Pools / 0xbow",
    program_metadata: "Program Metadata",
    pumpfun: "pump.fun",
    pumpfun_fee: "pump.fun fees",
    pumpswap_amm: "PumpSwap",
    quantum: "Quantum",
    quay: "Quay",
    railgun: "RAILGUN",
    raydium_amm_v4: "Raydium AMM v4",
    raydium_clmm: "Raydium CLMM",
    raydium_cpmm: "Raydium CPMM",
    raydium_launchlab: "Raydium LaunchLab",
    relay: "Relay",
    riptide: "Riptide",
    rootstock: "Rootstock",
    runes: "Runes",
    runner_rodeo: "RunnerRodeo",
    saber: "Saber",
    saber_decimals: "Saber (Decimals)",
    sanctum_infinity: "Sanctum Infinity",
    sanctum_multi_validator: "Sanctum Multi-Validator Pool",
    sanctum_prop_s: "Sanctum Prop S",
    sanctum_router: "Sanctum Router",
    sanctum_single_validator: "Sanctum Single-Validator Pool",
    sanctum_sols: "Sanctum SOLS",
    sanctum_spl_stake_pool: "Sanctum SPL Stake Pool",
    saros: "Saros",
    saros_dlmm: "Saros DLMM",
    scale_amm: "Scale AMM",
    scale_vmm: "Scale VMM",
    scorch: "Scorch",
    scorch_2: "Scorch",
    seaport: "Seaport",
    secp256k1_program: "Secp256k1 Signature Verify",
    solayer: "Solayer",
    solfi: "SolFi",
    solfi_v2: "SolFi v2",
    spl_memo_v1: "Memo v1",
    spl_memo_v2: "Memo",
    spl_token: "SPL Token",
    spl_token_2022: "Token-2022",
    spl_token_swap: "SPL Token Swap",
    stabble_clmm: "Stabble CLMM",
    stabble_stable_swap: "Stabble Stable Swap",
    stabble_weighted_swap: "Stabble Weighted Swap",
    stableswap: "Stableswap",
    stacks: "Stacks",
    stake: "Stake Program",
    stargate: "Stargate Finance",
    stepn: "StepN",
    sushiswap_router: "SushiSwap",
    sushiswap_v2_factory: "SushiSwap",
    system: "System Program",
    taurusfi: "TaurusFi",
    tensor_swap: "Tensor Swap",
    tessera_v: "TesseraV",
    thorchain: "THORChain",
    thorchain_deposit: "THORChain",
    thorchain_memo: "THORChain-style memo",
    thorchain_node: "THORChain node operations",
    tokemak_messaging: "Tokemak Cross-Chain Messaging",
    tornado_cash: "Tornado Cash",
    tornado_cash_nova: "Tornado Cash Nova",
    trench: "Trench",
    trends: "Trends",
    uma_optimistic_oracle: "UMA Optimistic Oracle",
    unattributed_coinjoin: "Unattributed CoinJoin",
    uniswap_permit2: "Permit2",
    uniswap_universal_router: "Uniswap Universal Router",
    uniswap_v1_exchange: "Uniswap V1",
    uniswap_v1_factory: "Uniswap V1",
    uniswap_v2_factory: "Uniswap V2",
    uniswap_v2_pair: "Uniswap V2",
    uniswap_v2_router: "Uniswap V2",
    uniswap_v3_factory: "Uniswap V3",
    uniswap_v3_pool: "Uniswap V3",
    uniswap_v3_position_manager: "Uniswap V3 Positions",
    uniswap_v3_router: "Uniswap V3",
    uniswap_v4: "Uniswap V4",
    uniswap_v4_position_manager: "Uniswap V4 Positions",
    usdt0: "USDT0 / Legacy Mesh",
    vault_liquid_unstake: "VaultLiquidUnstake",
    virtuals: "Virtuals",
    voltr: "Voltr",
    vote: "Vote Program",
    wasabi_coinjoin: "Wasabi CoinJoin",
    whalestreet: "WhaleStreet",
    whirlpool_coinjoin: "Whirlpool CoinJoin",
    wintermute: "Wintermute Market Maker",
    woofi: "WOOFi",
    wormhole: "Wormhole",
    xorca: "xORCA",
    zcash_shielded: "Zcash shielded pools",
    zeroex: "0x",
    zerofi: "ZeroFi",
    zkbob: "zkBob"
  }
};

// src/metadata-analytics/protocolNames.ts
var PROTOCOL_CATALOG_CATEGORIES = [
  "bridge",
  "exchange",
  "aggregator",
  "lending",
  "flashloan",
  "derivatives",
  "safe",
  "account_abstraction",
  "governance",
  "oracle",
  "infrastructure",
  "erc20",
  "nft",
  "staking",
  "mev",
  "exploit",
  "privacy",
  "gambling",
  "other"
];
var SnapshotSchema = z.object({
  names: z.record(z.string(), z.string()).default({}),
  categories: z.record(z.string(), z.string()).default({})
});
var SNAPSHOT = SnapshotSchema.parse(protocol_names_generated_default);
var NAMES = Object.freeze(SNAPSHOT.names);
var CATEGORIES = Object.freeze(SNAPSHOT.categories);
var KNOWN_CATEGORIES = new Set(PROTOCOL_CATALOG_CATEGORIES);
function catalogProtocolIds() {
  return Object.keys(NAMES);
}
function protocolDisplayName(protocolId) {
  if (!protocolId) return void 0;
  const name = NAMES[protocolId];
  return name && name.trim() ? name : void 0;
}
function protocolCategory(protocolId) {
  if (!protocolId) return void 0;
  const category = CATEGORIES[protocolId];
  return category && KNOWN_CATEGORIES.has(category) ? category : void 0;
}
function catalogCategories() {
  return CATEGORIES;
}

export { PROTOCOL_CATALOG_CATEGORIES, catalogCategories, catalogProtocolIds, protocolCategory, protocolDisplayName };
//# sourceMappingURL=chunk-LUR5XN2Z.js.map
//# sourceMappingURL=chunk-LUR5XN2Z.js.map